module.exports = __webpack_public_path__ + "static/img/section_5_bg.e1c9ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/section_5_bg.jpg
// module id = gAZp
// module chunks = 0